import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import GlobalLayout from '@/components/page/GlobalLayout';
import Contextmenu from '@/components/menu/Contextmenu';
import { mixin, mixinDevice } from '@/utils/mixin.js';
var indexKey = '/dashboard/Desktop';
export default {
  name: 'TabLayout',
  components: {
    GlobalLayout: GlobalLayout,
    Contextmenu: Contextmenu
  },
  mixins: [mixin, mixinDevice],
  data: function data() {
    return {
      pageList: [],
      linkList: [],
      activePage: '',
      menuVisible: false,
      menuItemList: [{
        key: '1',
        icon: 'arrow-left',
        text: '关闭左侧'
      }, {
        key: '2',
        icon: 'arrow-right',
        text: '关闭右侧'
      }, {
        key: '3',
        icon: 'close',
        text: '关闭其它'
      }]
    };
  },
  computed: {
    multipage: function multipage() {
      //判断如果是手机模式，自动切换为单页面模式
      if (this.isMobile()) {
        return false;
      } else {
        return this.$store.state.app.multipage;
      }
    }
  },
  created: function created() {
    if (this.$route.path != indexKey) {
      this.pageList.push({
        name: 'dashboard-Desktop',
        path: indexKey,
        fullPath: indexKey,
        meta: {
          icon: 'dashboard',
          title: '首页'
        }
      });
      this.linkList.push(indexKey);
    }

    this.pageList.push(this.$route);
    this.linkList.push(this.$route.fullPath);
    this.activePage = this.$route.fullPath;
  },
  watch: {
    '$route': function $route(newRoute) {
      this.activePage = newRoute.fullPath;

      if (!this.multipage) {
        this.linkList = [newRoute.fullPath];
        this.pageList = [Object.assign({}, newRoute)];
      } else if (this.linkList.indexOf(newRoute.fullPath) < 0) {
        this.linkList.push(newRoute.fullPath);
        this.pageList.push(Object.assign({}, newRoute));
      } else if (this.linkList.indexOf(newRoute.fullPath) >= 0) {
        var oldIndex = this.linkList.indexOf(newRoute.fullPath);
        var oldPositionRoute = this.pageList[oldIndex];
        this.pageList.splice(oldIndex, 1, Object.assign({}, newRoute, {
          meta: oldPositionRoute.meta
        }));
      }
    },
    'activePage': function activePage(key) {
      var index = this.linkList.lastIndexOf(key);
      var waitRouter = this.pageList[index];
      this.$router.push(Object.assign({}, waitRouter));
    },
    'multipage': function multipage(newVal) {
      if (!newVal) {
        this.linkList = [this.$route.fullPath];
        this.pageList = [this.$route];
      }
    }
  },
  methods: {
    changePage: function changePage(key) {
      this.activePage = key;
    },
    editPage: function editPage(key, action) {
      this[action](key);
    },
    remove: function remove(key) {
      if (key == indexKey) {
        this.$message.warning('首页不能关闭!');
        return;
      }

      if (this.pageList.length === 1) {
        this.$message.warning('这是最后一页，不能再关闭了啦');
        return;
      }

      this.pageList = this.pageList.filter(function (item) {
        return item.fullPath !== key;
      });
      var index = this.linkList.indexOf(key);
      this.linkList = this.linkList.filter(function (item) {
        return item !== key;
      });
      index = index >= this.linkList.length ? this.linkList.length - 1 : index;
      this.activePage = this.linkList[index];
    },
    onContextmenu: function onContextmenu(e) {
      var pagekey = this.getPageKey(e.target);

      if (pagekey !== null) {
        e.preventDefault();
        this.menuVisible = true;
      }
    },
    getPageKey: function getPageKey(target, depth) {
      depth = depth || 0;

      if (depth > 2) {
        return null;
      }

      var pageKey = target.getAttribute('pagekey');
      pageKey = pageKey || (target.previousElementSibling ? target.previousElementSibling.getAttribute('pagekey') : null);
      return pageKey || (target.firstElementChild ? this.getPageKey(target.firstElementChild, ++depth) : null);
    },
    onMenuSelect: function onMenuSelect(key, target) {
      var pageKey = this.getPageKey(target);

      switch (key) {
        case '1':
          this.closeLeft(pageKey);
          break;

        case '2':
          this.closeRight(pageKey);
          break;

        case '3':
          this.closeOthers(pageKey);
          break;

        default:
          break;
      }
    },
    closeOthers: function closeOthers(pageKey) {
      var index = this.linkList.indexOf(pageKey);

      if (pageKey == indexKey) {
        this.linkList = this.linkList.slice(index, index + 1);
        this.pageList = this.pageList.slice(index, index + 1);
        this.activePage = this.linkList[0];
      } else {
        var indexContent = this.pageList.slice(0, 1)[0];
        this.linkList = this.linkList.slice(index, index + 1);
        this.pageList = this.pageList.slice(index, index + 1);
        this.linkList.unshift(indexKey);
        this.pageList.unshift(indexContent);
        this.activePage = this.linkList[1];
      }
    },
    closeLeft: function closeLeft(pageKey) {
      if (pageKey == indexKey) {
        return;
      }

      var tempList = _toConsumableArray(this.pageList);

      var indexContent = tempList.slice(0, 1)[0];
      var index = this.linkList.indexOf(pageKey);
      this.linkList = this.linkList.slice(index);
      this.pageList = this.pageList.slice(index);
      this.linkList.unshift(indexKey);
      this.pageList.unshift(indexContent);

      if (this.linkList.indexOf(this.activePage) < 0) {
        this.activePage = this.linkList[0];
      }
    },
    closeRight: function closeRight(pageKey) {
      var index = this.linkList.indexOf(pageKey);
      this.linkList = this.linkList.slice(0, index + 1);
      this.pageList = this.pageList.slice(0, index + 1);

      if (this.linkList.indexOf(this.activePage < 0)) {
        this.activePage = this.linkList[this.linkList.length - 1];
      }
    },
    //update-begin-author:taoyan date:20190430 for:动态路由title显示配置的菜单title而不是其对应路由的title
    dynamicRouterShow: function dynamicRouterShow(key, title) {
      var keyIndex = this.linkList.indexOf(key);

      if (keyIndex >= 0) {
        var currRouter = this.pageList[keyIndex];
        var meta = Object.assign({}, currRouter.meta, {
          title: title
        });
        this.pageList.splice(keyIndex, 1, Object.assign({}, currRouter, {
          meta: meta
        }));
      }
    } //update-end-author:taoyan date:20190430 for:动态路由title显示配置的菜单title而不是其对应路由的title

  }
};